import React, { Component } from "react";
import { Modal, Header, Button, Icon } from "semantic-ui-react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";
import { withTranslation } from "react-i18next";

@observer
class ModalPageNotAccessible extends Component {
  render() {
    const { closeModal, pageNotAccessible, t } = this.props;

    return (
      <Modal open={pageNotAccessible}>
        <Header icon="exclamation circle" content={t("customerPortal:pageNotAccessible")} />
        <Modal.Content>
          <p>{t("customerPortal:pageNotAccessibleMessage")}</p>
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" inverted onClick={() => closeModal()}>
            <Icon name="backward" />
            {t("messages:close")}
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}
ModalPageNotAccessible.propTypes = {
  closeModal: PropTypes.func.isRequired,
  pageNotAccessible: PropTypes.bool.isRequired,
  t: PropTypes.func.isRequired,
};
export default withTranslation()(ModalPageNotAccessible);
